import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { BannerUnitService } from "../banner-unit.service";
import { UserInfoService, AemService } from "abs-ngx-library/src/lib/core";

@Component({
  selector: "banner-unit-v1",
  templateUrl: "./banner-unit-v1.component.html"
})
export class BannerUnitComponent implements OnChanges, AfterViewInit {
  @ViewChild("bannerUnitRef", {
    read: ElementRef,
    static: false,
  })
  public bannerUnitRef: ElementRef;
  public bannerGAMid: any;
  public bannerposition: any;
  public bannerElement: any = null;
  public banner: string = this._userInfoService.getBanner();
  public _window: any = window;
  public lazyLoad = false;
  public timeoutId = null;
  @Input() indextoInjectMidBanner: any;
  @Input() bannerPositionName: any;
  @Input() bannerPosition: any;
  @Input() categoryName: any;
  @Input() adUnitPathSuffix: any;
  constructor(
    public renderer: Renderer2,
    private _bannerUnitService: BannerUnitService,
    private _userInfoService: UserInfoService,
    private absAemService: AemService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if((changes['indextoInjectMidBanner'] && changes['indextoInjectMidBanner'].currentValue) || (changes['bannerPositionName'] && changes['bannerPositionName'].currentValue)){
      this.bannerposition = this._bannerUnitService.getBannerIndexMap().has(this.indextoInjectMidBanner)?this._bannerUnitService.getBannerIndexMap().get(this.indextoInjectMidBanner):this.bannerPositionName;

      // For SPA page, banner unit service will already have the banners initialized
      if(this._bannerUnitService.getBannerElementsHtmlMap().has(this.bannerposition)) {
        const bannerEle = this._bannerUnitService.getBannerElementsHtmlMap().get(this.bannerposition);
        this.bannerElement = this.updateAdUnitPath(bannerEle.cloneNode(true));
        this.bannerGAMid = this.bannerElement.querySelector("gam-section").getAttribute("data-gamid");
      } else {
        // For AEM page, getting the banner element from DOM
        const bannerElement = document.querySelector(`[data-bannerposition="${this.bannerposition}"]`);
        this.bannerGAMid = bannerElement?.getAttribute("data-gamid");
        this.bannerElement = bannerElement?.parentElement?.parentElement;
        if(this.bannerElement) {
            this.bannerElement.querySelector('[data-lazy-function]').innerHTML = '';
            this._bannerUnitService.getBannerElementsHtmlMap().set(this.bannerposition, this.updateAdUnitPath(this.bannerElement.cloneNode(true)));
            this.bannerElement.remove();
        }
      }

      const isLazyLoaded = this.bannerElement?.querySelector('.ab-lazy-function')?.getAttribute("data-lazy-function");
      if(isLazyLoaded) {
        this.lazyLoad = true;
      } else {
        this.placeBannerUnit();
      }
    }
  }

  updateAdUnitPath(bannerElement) {
    // update adUnitPath with suffix if provided
    if(this.adUnitPathSuffix && this.adUnitPathSuffix.length > 0 && window["AB"]?.userInfo?.banner) {
        const gamSection = bannerElement.querySelector("gam-section");
        gamSection.setAttribute("data-adunitpath", window["AB"].userInfo.banner + this.adUnitPathSuffix);
        //This is to fix the Offer Details issue where we need to destroy the slot and recreate due to SPA navigation issue
        const existingSlot = window['googletag']?.pubads()?.getSlots()?.find(slot => slot?.getSlotElementId() === 'gamcontainer_' + gamSection.getAttribute("data-gamid"));
        if(existingSlot) {
            window['googletag']?.destroySlots([existingSlot]);
        }
    }
    return bannerElement;
  }

  ngAfterViewInit(): void {
    this.checkAdBlockerAndInitGAM();
  }

  checkAdBlockerAndInitGAM() {
    const $this = this;
    // check for AdBlocker check done by GPT
    if (window["checkAdBlocker"] == undefined) {
      // wait for adBlockerLoadChecked event
      window.addEventListener("adBlockerLoadChecked", function (eventResponse) {
          if(!$this.lazyLoad && !$this.checkSlotLoaded($this.bannerGAMid)) {
              $this.placeBannerUnit();
          }
      });
    } 
  }

  checkSlotLoaded(gamId){
      if (gamId && window['googletag'] && window['googletag']?.pubads && window['googletag']?.pubads()?.getSlots) {
          return window['googletag']?.pubads()?.getSlots()?.filter(slot => slot?.getSlotElementId()?.includes(gamId))?.length > 0;
      }
      return false;
  }

  public placeBannerUnit() {
    setTimeout(() => {
        //check for component, placeholder and adblocker
        if (!this.bannerElement || !this.bannerUnitRef || !window["googletag"] || window["googletag"]?._loaded_ == false) {
          this.bannerUnitRef?.nativeElement?.parentElement?.classList?.add('d-none');
          return;
        }
        this.bannerUnitRef?.nativeElement?.parentElement?.classList?.remove('d-none');
        //append banner unit as a node to the placeholder
        this.renderer.appendChild(this.bannerUnitRef.nativeElement, this.bannerElement);

        // set categoryName to pass in banner as q
        if (this.categoryName) {
            this.bannerElement.querySelector("gam-section")?.setAttribute('data-categoryName', this.categoryName);
        }

        //Pass executeBanner as callback with isSPApage as param in addToQueue
        if(this.isInGridBanner()) {
            this._bannerUnitService.addToQueue(this);
        } else {
            this.executeBanner();
        }

    }, 0);
  }

  isInGridBanner() {
      const pathName = window?.location?.pathname;
      const isDelaySupportedBanner = ['midb1', 'midb2', 'midb3'].indexOf(this.bannerposition) != -1;
      const isInGridPage = pathName?.includes('/loyalty/coupons-deals') || pathName?.includes('/foru/coupons-deals');
      return isDelaySupportedBanner && isInGridPage;
  }

  public executeBanner(){
      const isSPApage = this.bannerElement.querySelector("gam-section")?.getAttribute('data-spapage');
      if(this.checkSlotLoaded(this.bannerGAMid)) {
          //emit an event to refresh GAM medium banner component
          if (this.bannerGAMid) {
              const ev = new CustomEvent("reloadGAM_" + this.bannerGAMid, {
                  detail: { bannerGAMId: this.bannerGAMid },
              });
              document.dispatchEvent(ev);
          }
      } else {
          //Execute the script tag inside Banner
          const scripts = this.bannerElement.querySelectorAll('script');
          scripts?.forEach(oldScript => {
              const newScript = document.createElement('script');
              // Copy the script content
              newScript.text = oldScript.textContent;
              // Replace the old script with the new one to force execution
              oldScript.parentNode.replaceChild(newScript, oldScript);
          });
          //If there is lazy function inside the banner then execute it because it will not be executed automatically due to SPA
          //read lazy function from the banner inside data-lazy-function 2 level deep
          const absLazyFunction = this.bannerElement.querySelector('.ab-lazy-function')?.getAttribute("data-lazy-function");
          //check if function exists on window object under lazyFunctions then execute it
          if(absLazyFunction && window["lazyFunctions"] && window["lazyFunctions"][absLazyFunction]) {
              window["lazyFunctions"][absLazyFunction]();
          }
      }
      // check if GAM is loaded within given time or hide the ad if not loaded
      this._bannerUnitService.trackSlotLoaded(this.bannerGAMid, this.bannerElement, this.bannerUnitRef);
  }
}
